import React from 'react'
import useFormValidation from "../../components/auth/useFormValidation";
import validateCreateTema from "../../components/auth/validateCreateTema";
import FirebaseContext from "../../firebase/context";

// import ImageUploader from 'react-images-upload';
import { v4 as uuidv4 } from 'uuid';
import FileUploader from "react-firebase-file-uploader";
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import { Link, withRouter } from "react-router-dom";
import CompUpload from './CompUpload';

import { Button, TextField, TableRow, TableCell, Typography } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';

const INITIAL_STATE = {
    tituloCiclo: "",
};


const CompTemaListAdd = ({ props, cursoSelect, setShowTemaFormAdd, setPracticaURL, practicaURL }) => {
    const { user, firebase } = React.useContext(FirebaseContext);

    const INITIAL_STATE = {
        idCurso: cursoSelect,
        tituloTema: "",
        video: "",
        practica: "",
        postedBy: {
            id: user.uid,
            name: user.displayName
          },
          voteCount: 0,
          votes: [],
          comments: [],
          created: Date.now()
 
    };


    
    const { handleSubmit, handleChange, values, errors } = useFormValidation(
        INITIAL_STATE,
        validateCreateTema,
        handleCreateTema
    );

    function handleCreateTema() {

        if (!user) {
            props.history.push("/login");
        } else {
            // const { idCurso, tituloTema, video, practica } = values;
            const { idCurso, tituloTema, video} = values;
            const practica = practicaURL
            const newTema = {
                idCurso,
                tituloTema,
                video,
                practica,
                postedBy: {
                    id: user.uid,
                    name: user.displayName
                  },
                  voteCount: 0,
                  votes: [],
                  comments: [],
                  created: Date.now()
            };


            firebase.db.collection("colTemas").add(newTema);
            setShowTemaFormAdd(false);
        }
    }


    return (
        <React.Fragment>
            <TableRow >
            <TableCell align='justify'>
            <form onSubmit={handleSubmit} >
            <TextField
                            fullWidth
                            variant="outlined"
                            label="Titulo de Tema"
                            name="tituloTema"
                            margin="normal"
                            placeholder="Titulo de Tema"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.tituloTema && "error-input"}
                            value={values.tituloTema}
                        />
                {errors.tituloTema && <p className="error-text">{errors.tituloTema}</p>}
                <TextField
                            fullWidth
                            variant="outlined"
                            label="Direccion URL de Video"
                            name="video"
                            margin="normal"
                            placeholder="Direccion URL de Video"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.video && "error-input"}
                            value={values.video}
                        />
                {errors.video && <p className="error-text">{errors.video}</p>}
                <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className="button"
                            type="submit"
                            startIcon={<SaveIcon />}
                        >
                            GUARDAR
                               </Button>
                <Button
                            variant="contained"
                            color="error"
                            size="small"
                            type="button"
                            onClick={() => setShowTemaFormAdd(false)}
                            startIcon={<CancelIcon />}
                        >
                            CANCELAR
                               </Button>
            </form>
            </TableCell>
            <TableCell>
            <Typography >URL de Practica: {practicaURL}</Typography>
            <CompUpload setPracticaURL={setPracticaURL}/>
            </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default withRouter(CompTemaListAdd)
